/**
 * @Desription: 方法-登录超时
 * @Author: netstar.sjj
 * @Date: 2021-10-26 16:05:00
 * @names: reEntryDialogManager
*/
declare const window:any;
namespace reEntryDialogManager{
    export const dataManager:any = {
        userTime: "",  	  // 用户所需时间
        millsecond: "",	  // 毫秒值
        timerId: "",		  // 计时器
        zeroTime: "",
        userInfo: "",	  // 用户相关信息(不包括密码等私密信息)
        arr:[],
    }
    export function init(time?:any) {
        let timeLine:any;
        if (typeof (time) == "undefined") {
            timeLine = 60;
        } else {
            timeLine = time;
        }
        if (window.location.pathname.indexOf('tp-editor') == -1) {
            if(typeof(window.NetstarHomeConfig) != 'undefined'){
                if(window.NetstarHomeConfig){
                    let systemInfo = window.NetstarHomeConfig.systemInfo
                    window.localStorage.setItem("systemInfo", JSON.stringify(systemInfo));
                }
            }
            
        }
        window.NSUtils.reEntryDialog.dealTime(timeLine, function (millsecond:any) {
            window.NSUtils.reEntryDialog.startTimer(millsecond)
        })
    }
    // 处理时间
    export function dealTime(time:any, callback:Function) {
        if (time == 0) {
            window.NSUtils.reEntryDialog.dataManager.zeroTime = time
        } else {
            window.NSUtils.reEntryDialog.dataManager.userTime = time;
        }
        let millsecond = time * 60 * 1000;
        window.NSUtils.reEntryDialog.dataManager.millsecond = millsecond;
        callback(millsecond);
    }
    export function reLoginDialogHtml(topOrgName:string,account:string) {
        let $ = window.jQuery;
        let loginDialog = `<div id="loginPanel" class="simple-login">
                    <div class="simple-login-container">
                        <div class="simple-login-body">
                            <div class="tips">
                                <div class="tips-item">
                                    <span>${window.language.login.name.expire}</span>
                                </div>
                                <div class="tips-item">
                                    <span>${window.language.login.name.reset}</span>
                                </div>
                            </div>
                            <form class="form">
                                <div class="form-group">
                                    <div class="form-item ${topOrgName ? 'hide' : ''}">
                                        <div class="input-group">
                                            <input type="text" class="form-control" placeholder="${window.language.login.name.orgName}" id="orgname" value="${topOrgName ? topOrgName : ""}">
                                            <div class="input-addon">
                                                <i class="icon icon-user"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-item">
                                        <div class="input-group">
                                            <input type="text" class="form-control" placeholder="${window.language.login.name.username}" id="username" value="${account ? account : ""}">
                                            <div class="input-addon">
                                                <i class="icon icon-user"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-item">
                                        <div class="input-group">
                                            <input type="password" class="form-control" id="password" placeholder="${window.language.login.name.pwd}">
                                            <div class="input-addon">
                                                <i class="icon icon-password"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-item hide" id="verificationcode-hidden">
                                        <input class="input-group" type="text" id="verificationcode" placeholder="${window.language.login.name.verifiy}">
                                        <div class="verify-code" id="verificationimg">
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div class="simple-login-alert hide" id="pwmsg">
                                
                            </div>
                        </div>
                        <div class="simple-login-footer">
                            <div class="btn-group">
                                <button class="btn btn-primary btn-block" " id="btn-submit">
                                    <span>${window.language.login.name.login}</span>
                                </button>
                                <button class="btn btn-default btn-block btn-outline" id="nsLoginStyle-loginDiv-btns">
                                    <span>${window.language.login.name.changeAccount}</span>
                                </button>
                            </div>
                        </div>
                        <div class="simple-login-bg"></div>
                    </div>
                </div>`;
        return loginDialog;
    }
    // 清除token
    export function clearToken(callback:Function) {
        let ajaxConfig = {
            url:'/logout',
            type:"POST",
            contentType:'application/json',
            data:{}
        }
        if(window.NSUtils.OAuthCode.get()){
            window.NSUtils.ajax(ajaxConfig, function(res:any){
                if(res.success){
                    window.NSUtils.OAuthCode.clear();
                    callback();
                }else{
                    callback();
                }
            })
        }else{
            callback();
        }
    }
    // 添加html
    export function renderHtml(){
        let $ = window.jQuery;
        let userInfo:any = {};
        if(typeof(localStorage.getItem("loginProperty"))=='string'){
            //sjj 20210719 添加判断 如果当前存储对象不存在无法进行json解析转化
            if(localStorage.getItem("loginProperty")==='undefined'){

            }else{
                if(JSON.parse(localStorage.getItem("loginProperty")) && JSON.parse(localStorage.getItem("loginProperty")).user){
                    userInfo = JSON.parse(localStorage.getItem("loginProperty")).user;
                }
            }
        }
        window.NSUtils.reEntryDialog.dataManager.userInfo = userInfo;
        let userInfoObj = window.NSUtils.reEntryDialog.dataManager.userInfo;
        window.NSUtils.reEntryDialog.clearToken(function () {
            $("body #loginPanel").remove();
            clearTimeout(window.NSUtils.reEntryDialog.dataManager.timerId);
            if(window.NSUtils.reEntryDialog.dataManager.arr.length>0){
                for(let i = 0; i < window.NSUtils.reEntryDialog.dataManager.arr.length; i++){
                    clearTimeout(window.NSUtils.reEntryDialog.dataManager.arr[i]);
                }
                window.NSUtils.reEntryDialog.dataManager.arr = [];
            }
            $("body").append(window.NSUtils.reEntryDialog.reLoginDialogHtml(userInfoObj.orgName, userInfoObj.account));
            $("#nsLoginStyle-loginDiv-btns").click(function () {
                let isToLogin:boolean = false;
                if(typeof(window.NSHome)=='object'){
                    if(typeof(window.NSHome.toLogin)=='function'){
                        isToLogin = true;
                        window.NSHome.toLogin();
                    }
                }
                if(isToLogin === false){
                    if(typeof(window.NSMobileHome)=='object'){
                        if(typeof(window.NSMobileHome.toLogin)=='function'){
                            isToLogin = true;
                            window.NSMobileHome.toLogin();
                        }
                    }
                }
                if(isToLogin === false){
                    if(typeof(window.NetstarHomePage)=='object'){
                        if(typeof(window.NetstarHomePage.config)=='object'){
                            if(typeof(window.NetstarHomePage.config.toLoginPage)=='function'){
                                isToLogin = true;
                                window.NetstarHomePage.config.toLoginPage();
                            }
                        }
                    }
                }
                if(isToLogin === false){
                    console.warn('不识别的方法，无法进行跳转');
                }
            })
            window.NSUtils.reEntryDialog.initReLogin();
        })
    }
    // 启动延时器
    export function startTimer(millsecond:any) {
        window.NSUtils.reEntryDialog.dataManager.timerId = setTimeout(function () {
            window.NSUtils.reEntryDialog.renderHtml();
        }, millsecond)
        if(millsecond == 0){

        }else{
            window.NSUtils.reEntryDialog.dataManager.arr.push(window.NSUtils.reEntryDialog.dataManager.timerId);
            if(window.NSUtils.reEntryDialog.dataManager.arr.length > 1){
                let timeArr = [];
                for(let i = 0; i < window.NSUtils.reEntryDialog.dataManager.arr.length-1; i ++){
                    clearTimeout(window.NSUtils.reEntryDialog.dataManager.arr[i]);
                }
                timeArr.push(window.NSUtils.reEntryDialog.dataManager.arr[window.NSUtils.reEntryDialog.dataManager.arr.length-1]);
                window.NSUtils.reEntryDialog.dataManager.arr = timeArr;
            }
        }
    }
    export function initReLogin() {
        if(typeof(window.NetstarLogin)=='object'){
            window.NetstarLogin.init(window.NetstarHomeConfig.loginConfig);
        }else if(typeof(window.NSLogin)=='object'){
            window.NSLogin.init(window.NetstarHomeConfig.loginConfig);
        }
    }
    // 清除定时器
    export function clearTimeoutFun() {
        if (window.NSUtils.reEntryDialog.dataManager.timerId && window.NSUtils.reEntryDialog.dataManager.userTime) {
            clearTimeout(window.NSUtils.reEntryDialog.dataManager.timerId);
            if(window.NSUtils.reEntryDialog.dataManager.arr.length > 1){
                let timeArr = [];
                for(let i = 0; i < window.NSUtils.reEntryDialog.dataManager.arr.length-1; i ++){
                    clearTimeout(window.NSUtils.reEntryDialog.dataManager.arr[i]);
                }
                timeArr.push(window.NSUtils.reEntryDialog.dataManager.arr[window.NSUtils.reEntryDialog.dataManager.arr.length-1]);
                window.NSUtils.reEntryDialog.dataManager.arr = timeArr;
            }
            window.NSUtils.reEntryDialog.init(window.NSUtils.reEntryDialog.dataManager.userTime);
        } else {
            return
        }
    }
}
export default reEntryDialogManager;